module.exports = __webpack_public_path__ + "img/wechat.034e3556.png";